import { faker } from '@faker-js/faker'

import { HospitalVisitorOrderSummariesView, HospitalVisitorOrderView } from '../../contracts/hospital'
import { asBuilder } from '../asBuilder'

export const getHospitalVisitorOrderView = asBuilder((): HospitalVisitorOrderView => {
  return {
    hospitalId: faker.number.int(),
    branch: faker.lorem.word(),
    category: faker.helpers.arrayElement(['CONSULTATION', 'PROCEDURE']),
    status: faker.helpers.arrayElement(['RESERVATION', 'VISIT', 'PROGRESS']),
    waitingCount: faker.number.int(),
    createdAt: faker.date.recent().toISOString(),
  }
})

export const getHospitalVisitorOrderSummariesView = asBuilder((): HospitalVisitorOrderSummariesView => {
  return {
    hospitalId: faker.number.int(),
    summaries: faker.helpers.multiple(() => ({
      branch: faker.lorem.word(),
      category: faker.helpers.arrayElement(['CONSULTATION', 'PROCEDURE']),
      waitingCount: faker.number.int(),
    })),
  }
})
